"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarPage = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Calendar_1 = require("../../components/molecules/Calendar");
const EmptyCalendar_1 = require("../../components/molecules/Calendar/EmptyCalendar");
const HeaderToggle_1 = __importDefault(require("../../components/molecules/Calendar/HeaderToggle/HeaderToggle"));
const FixedStreamStationHeader_1 = require("../../components/molecules/FixedStreamStationHeader");
const Graph_1 = require("../../components/organisms/Graph/Graph");
const MeasurementComponent_1 = __importDefault(require("../../components/organisms/Graph/MeasurementComponent"));
const TimeRage_1 = __importDefault(require("../../components/organisms/Graph/TimeRage"));
const ResetButton_1 = require("../../components/organisms/ThresholdConfigurator/ThresholdButtons/ResetButton");
const ThresholdButton_1 = require("../../components/organisms/ThresholdConfigurator/ThresholdButtons/ThresholdButton");
const UniformDistributionButton_1 = require("../../components/organisms/ThresholdConfigurator/ThresholdButtons/UniformDistributionButton");
const fixedStreamSelectors_1 = require("../../store/fixedStreamSelectors");
const fixedStreamSlice_1 = require("../../store/fixedStreamSlice");
const hooks_1 = require("../../store/hooks");
const movingCalendarStreamSlice_1 = require("../../store/movingCalendarStreamSlice");
const thresholdSlice_1 = require("../../store/thresholdSlice");
const filters_1 = require("../../types/filters");
const useBackNavigation_1 = require("../../hooks/useBackNavigation");
const mapParamsHandler_1 = require("../../utils/mapParamsHandler");
const measurementsCalc_1 = require("../../utils/measurementsCalc");
const useScreenSizeDetection_1 = __importDefault(require("../../utils/useScreenSizeDetection"));
const ThresholdConfigurator_1 = require("../../components/organisms/ThresholdConfigurator/ThresholdConfigurator");
const S = __importStar(require("./CalendarPage.style"));
const CalendarPage = ({ children }) => {
    var _a, _b;
    const dispatch = (0, hooks_1.useAppDispatch)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleCalendarGoBack = (0, useBackNavigation_1.useCalendarBackNavigation)();
    const { unitSymbol, streamId } = (0, mapParamsHandler_1.useMapParams)();
    const fixedStreamData = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedData);
    const movingCalendarData = (0, hooks_1.useAppSelector)(movingCalendarStreamSlice_1.movingData);
    const { startTime, endTime } = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedStreamShortInfo);
    const isLoading = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectIsLoading);
    const rangeDisplayRef = (0, react_1.useRef)(null);
    const { formattedMinTime, formattedMaxTime } = (0, measurementsCalc_1.formatTime)(startTime, endTime);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)("");
    const [initialDataFetched, setInitialDataFetched] = (0, react_1.useState)(false);
    // Maintain selectedTimestamp across fetches until explicitly cleared.
    const [selectedTimestamp, setSelectedTimestamp] = (0, react_1.useState)(null);
    const calendarIsVisible = (movingCalendarData.data.length > 0 || isLoading) &&
        streamId &&
        fixedStreamData.stream.startTime;
    const streamEndTime = (_b = (_a = fixedStreamData.stream.endTime) !== null && _a !== void 0 ? _a : fixedStreamData.stream.lastUpdate) !== null && _b !== void 0 ? _b : (0, moment_timezone_1.default)().format("YYYY-MM-DD");
    (0, react_1.useEffect)(() => {
        if (streamId && !fixedStreamData.measurements.length) {
            dispatch((0, fixedStreamSlice_1.fetchFixedStreamById)(streamId));
        }
    }, [streamId, dispatch, fixedStreamData.measurements.length]);
    (0, react_1.useEffect)(() => {
        if (fixedStreamData.stream) {
            dispatch((0, thresholdSlice_1.setDefaultThresholdsValues)(fixedStreamData.stream));
        }
    }, [fixedStreamData.stream, dispatch]);
    (0, react_1.useEffect)(() => {
        if (!initialDataFetched &&
            streamId &&
            fixedStreamData.stream.startTime &&
            streamEndTime) {
            dispatch((0, movingCalendarStreamSlice_1.fetchNewMovingStream)({
                id: streamId,
                startDate: fixedStreamData.stream.startTime,
                endDate: streamEndTime,
            }));
            setInitialDataFetched(true);
        }
    }, [
        initialDataFetched,
        streamId,
        fixedStreamData.stream.startTime,
        streamEndTime,
        dispatch,
    ]);
    (0, react_1.useEffect)(() => {
        window.addEventListener("popstate", handleCalendarGoBack);
        return () => window.removeEventListener("popstate", handleCalendarGoBack);
    }, [handleCalendarGoBack]);
    const handleDayClick = (timestamp) => {
        setSelectedTimestamp(timestamp);
    };
    const renderMobileGraph = () => (react_1.default.createElement(S.GraphContainer, { "$isMobile": isMobile },
        react_1.default.createElement(HeaderToggle_1.default, { "data-testid": "graph-header", isCalendarPage: true, titleText: react_1.default.createElement(S.StyledContainer, null, t("calendarHeader.graphTitle")), componentToToggle: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(S.SelectLabelContainer, null, t("calendarHeader.selectRange")),
                react_1.default.createElement(TimeRage_1.default, { "data-testid": "time-range", ref: rangeDisplayRef, minTime: formattedMinTime, maxTime: formattedMaxTime }),
                react_1.default.createElement(Graph_1.Graph, { "data-testid": "graph", streamId: Number(streamId), sessionType: filters_1.SessionTypes.FIXED, isCalendarPage: true, rangeDisplayRef: rangeDisplayRef, selectedTimestamp: selectedTimestamp, onDayClick: handleDayClick }),
                react_1.default.createElement(MeasurementComponent_1.default, null)) })));
    const renderThresholdContainer = () => (react_1.default.createElement(S.ThresholdContainer, { "$isMobile": isMobile },
        react_1.default.createElement(HeaderToggle_1.default, { "data-testid": "threshold-toggle", titleText: react_1.default.createElement(S.StyledContainer, null,
                t("calendarHeader.legendTitle"),
                react_1.default.createElement(S.Units, null,
                    "(",
                    unitSymbol,
                    ")"),
                !isMobile && (react_1.default.createElement(S.ThresholdButtonsContainer, null,
                    react_1.default.createElement(ResetButton_1.ResetButton, { "data-testid": "reset-threshold", variant: ThresholdButton_1.ThresholdButtonVariant.TextWithIcon, swapIconTextPosition: true }),
                    react_1.default.createElement(UniformDistributionButton_1.UniformDistributionButton, { variant: ThresholdButton_1.ThresholdButtonVariant.TextWithIcon, swapIconTextPosition: true, hasErrorMessage: setErrorMessage })))), componentToToggle: isMobile ? (react_1.default.createElement(ThresholdConfigurator_1.ThresholdsConfigurator, { "data-testid": "threshold-configurator", resetButtonVariant: ThresholdButton_1.ThresholdButtonVariant.TextWithIcon, resetButtonText: t("thresholdConfigurator.resetButton"), useColorBoxStyle: true, uniformDistributionButtonText: t("thresholdConfigurator.uniformDistributionButton"), uniformDistributionButtonVariant: ThresholdButton_1.ThresholdButtonVariant.TextWithIcon })) : (react_1.default.createElement(S.SliderWrapper, null,
                errorMessage && react_1.default.createElement(S.ErrorMessage, null, errorMessage),
                react_1.default.createElement(ThresholdConfigurator_1.ThresholdsConfigurator, { "data-testid": "threshold-configurator", noDisclaimers: true }))) })));
    const renderDesktopGraph = () => (react_1.default.createElement(S.GraphContainer, { "$isMobile": isMobile },
        react_1.default.createElement(HeaderToggle_1.default, { titleText: react_1.default.createElement(S.StyledContainerWithGraph, null,
                t("calendarHeader.graphTitle"),
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(MeasurementComponent_1.default, null),
                    react_1.default.createElement(TimeRage_1.default, { ref: rangeDisplayRef, minTime: formattedMinTime, maxTime: formattedMaxTime }))), componentToToggle: react_1.default.createElement(Graph_1.Graph, { streamId: streamId, sessionType: filters_1.SessionTypes.FIXED, isCalendarPage: true, rangeDisplayRef: rangeDisplayRef, selectedTimestamp: selectedTimestamp, onDayClick: handleDayClick }) })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(S.CalendarPageLayout, null,
            react_1.default.createElement(S.StationDataContainer, null,
                react_1.default.createElement(FixedStreamStationHeader_1.FixedStreamStationHeader, { "data-testid": "fixed-stream-station-header" }),
                isMobile && renderMobileGraph(),
                renderThresholdContainer(),
                calendarIsVisible ? (react_1.default.createElement(Calendar_1.Calendar, { "data-testid": "calendar", streamId: streamId, minCalendarDate: fixedStreamData.stream.startTime, maxCalendarDate: streamEndTime, onDayClick: handleDayClick, selectedTimestamp: selectedTimestamp })) : (react_1.default.createElement(EmptyCalendar_1.EmptyCalendar, null)),
                !isMobile && renderDesktopGraph()))));
};
exports.CalendarPage = CalendarPage;
